// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { StyledClickable, StyledTypography } from "@insite/mobius/Link";
import { footerContainerStyles } from "@mcmc/Overrides/Widgets/Footer/FooterContainer";
import { css } from "styled-components";

footerContainerStyles.column1LinkListWrapper = {
    css: css`
        ${footerContainerStyles.column1LinkListWrapper?.css}
        ${StyledClickable} {
            ${StyledTypography} {
                font-weight: bold;
                line-height: 19px;
            }
        }
    `,
};

footerContainerStyles.copyrightMessageGridItemAndLogoWrapper = {
    css: css`
        ${footerContainerStyles.copyrightMessageGridItemAndLogoWrapper?.css}
        & >:first-child > ${StyledWrapper} {
            width: 176px;
        }
    `,
};
